/* unplugin-vue-components disabled */import { render } from "./UserOrder.vue?vue&type=template&id=01850574&scoped=true"
import script from "./UserOrder.vue?vue&type=script&lang=js"
export * from "./UserOrder.vue?vue&type=script&lang=js"

import "./UserOrder.vue?vue&type=style&index=0&id=01850574&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/quan-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01850574"]])

export default __exports__